import { render } from "./ApiLogs.vue?vue&type=template&id=42216ad9"
import script from "./ApiLogs.vue?vue&type=script&lang=js"
export * from "./ApiLogs.vue?vue&type=script&lang=js"

import "./ApiLogs.vue?vue&type=style&index=0&id=42216ad9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__